import * as THREE from "three";
import { emitCustomEvent } from "react-custom-events";
import * as turf from "@turf/turf";
import { ControlPointItem } from "../../../types/interfaces";
import { DataStore } from "../../../store/DataStore";

export const createMeasure = (pointItem: ControlPointItem) => {
    const measure = new window.potree.Measure();

    // custom properties
    measure.idValue = pointItem.no;
    /// /////////////////////////////////

    measure.showDistances = true;
    measure.showArea = false;
    measure.showAngles = false;
    measure.showCoordinates = false;
    measure.showHeight = false;
    measure.showCircle = false;
    measure.showAzimuth = false;
    measure.showEdges = true;
    measure.closed = false;
    measure.maxMarkers = 1;

    measure.name = pointItem.title || "P";

    window.potreeViewer.scene.addMeasurement(measure);

    const p = new THREE.Vector3(pointItem.x, pointItem.y, pointItem.z);
    measure.addMarker(p);

    const sphereMouseClick = () => {
        const selectedControlPointID = DataStore.selectedControlPointID;
        if (selectedControlPointID && selectedControlPointID !== measure.idValue) {
            const measureForControlPoint = window.measures[selectedControlPointID];
            emitCustomEvent("ClickTiePoint", {
                id: measure.idValue,
                haveTie: measureForControlPoint.spheres.length > 1
            });
        }
    };

    measure.spheres[0].addEventListener("click", sphereMouseClick);

    window.measures[pointItem.no] = measure;
};

export const showControlPoint = (projectId: string, pointId: string) => {
    const projectItem = DataStore.allProjectData.find((p) => p.id === projectId);
    if (projectItem) {
        const pointsData = projectItem.data;
        const pointItem = pointsData.find((p) => p.no === pointId);
        if (pointItem) {
            const measure = window.measures[pointItem.no];
            if (measure) {
                measure.visible = pointItem.show;
            }
        }
    }
};

export const selectTie = (pointItem: ControlPointItem, previousPointItem: ControlPointItem | undefined) => {
    window.potreeViewer.scene.view.lookAt(pointItem.x, pointItem.y, pointItem.z);

    const ptIndex = pointItem.no;
    const measure = window.measures[ptIndex];

    if (measure.spheres.length > 1) {
        measure.updateMarkerColor(0, new THREE.Color(0, 0, 1));
    } else {
        measure.spheres[0].material.color = new THREE.Color(0, 0, 1);
    }

    if (previousPointItem) {
        const previousMeasure = window.measures[previousPointItem.no];
        if (previousMeasure.spheres.length > 1) {
            previousMeasure.updateMarkerColor(0, new THREE.Color(1, 0, 0));
        } else {
            previousMeasure.spheres[0].material.color = new THREE.Color(1, 0, 0);
        }
    }

    DataStore.selectedControlPointID = pointItem.no;
};

export const addTie = (controlPointItem: ControlPointItem, tiePointItem: ControlPointItem, haveTie: boolean) => {
    const ptIndex = controlPointItem.no;
    const measure = window.measures[ptIndex];

    const p = new THREE.Vector3(tiePointItem.x, tiePointItem.y, tiePointItem.z);
    measure.addMarker(p);

    if (haveTie) {
        measure.removeMarker(1);
    }

    measure.updateMarkerColor(0, new THREE.Color(1, 0, 0));
    measure.updateMarkerColor(1, new THREE.Color(0, 1, 0));

    DataStore.selectedControlPointID = ""
};

export const removeMeasure = (id: string) => {
    const measure = window.measures[id];
    window.potreeViewer.scene.removeMeasurement(measure);
    delete window.measures[id];
};

export const flyToProject = (points: ControlPointItem[]) => {
    const xArray = points.map((p) => p.x);
    const yArray = points.map((p) => p.y);

    const features = turf.points(points.map((p) => [p.x, p.y]));

    const center = turf.center(features);

    const distance = turf.distance(
        turf.point([Math.min(...xArray), Math.min(...yArray)]),
        turf.point([Math.max(...xArray), Math.max(...yArray)])
    );

    const centerX = center.geometry.coordinates[0];
    const centerY = center.geometry.coordinates[1];

    const view = window.potreeViewer.scene.view;

    view.position.set(centerX, centerY, distance / 2);
    view.lookAt(new THREE.Vector3(centerX, centerY, distance / 4));
};
